import { useFs_Species_List } from '@frontend/hooks/firestore/species/list';
import { useFs_Species_GetById } from '@frontend/hooks/firestore/species/getById';

export namespace useFs_Species {
  export const list = useFs_Species_List;
  export const getById = useFs_Species_GetById;
}
